var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(!_vm.$route.meta.keep)?_c('router-view'):_vm._e(),_c('keep-alive',[(_vm.$route.meta.keep)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }